module.exports = __webpack_public_path__ + "img/Extreme Fitness Center.f6bdf9a4.svg";